/** Editable scalar profile fields, as they sit in the form. */
export interface IPersonalInfoSnapshot {
  firstName: string;
  lastName: string;
  preferredName: string;
  /** E.164-normalized phone, or '' when absent. */
  phoneNumber: string;
}

/** Subset of `UpdateUserInput` carrying only the fields that changed. */
export interface IUpdateUserFields {
  firstName?: string;
  lastName?: string;
  preferredName?: string;
  phoneNumber?: string;
}

/**
 * Returns only the fields that differ between `original` and `current`, so the
 * `updateUser` mutation never sends an unchanged value (which, for phone, would
 * needlessly clear verification server-side).
 */
export const diffPersonalInfo = (
  original: IPersonalInfoSnapshot,
  current: IPersonalInfoSnapshot
): IUpdateUserFields => {
  const diff: IUpdateUserFields = {};
  if (current.firstName !== original.firstName) {
    diff.firstName = current.firstName;
  }
  if (current.lastName !== original.lastName) {
    diff.lastName = current.lastName;
  }
  if (current.preferredName !== original.preferredName) {
    diff.preferredName = current.preferredName;
  }
  if (current.phoneNumber !== original.phoneNumber) {
    diff.phoneNumber = current.phoneNumber;
  }
  return diff;
};

/** True when `diffPersonalInfo` found at least one changed field. */
export const hasUpdateUserChanges = (diff: IUpdateUserFields): boolean => Object.keys(diff).length > 0;
